interface SimplePagerProps {
    PageSize: number;
    TotalRows: number;
    CurrentPage?: number;
    CurrentRowOffset?: number;
    EventToDispatchOnPageChange?: number;
    isControlDisabled?: boolean;
    changePageFunction?: (pageNumber: number) => void;
}

class SimplePagerControl extends React.Component<SimplePagerProps, never> {
    public render(): JSX.Element {
        let offset = 0;
        let resultsTo = 0;
        let totalResults = 0;

        if (this.props.TotalRows > 0) {
            offset = this.getCurrentOffset();
            totalResults = this.props.TotalRows;

            resultsTo = offset + this.props.PageSize;
            if (totalResults < resultsTo)
                resultsTo = totalResults;
        }

        return (
            <div>
                <button className="btn btn-primary" onClick={e => this.previousPage(e)} style={{ marginRight: "5px" }} disabled={this.props.isControlDisabled || offset <= 0}>
                    <span data-cy="simple-pager-control-left-arrow">{"<"}</span>
                </button>
                <button className="btn btn-primary" onClick={e => this.nextPage(e)} style={{ marginRight: "5px" }} disabled={this.props.isControlDisabled || resultsTo >= totalResults}>
                    <span data-cy="simple-pager-control-right-arrow">{">"}</span>
                </button>
                <span>{offset + 1} - {resultsTo} {cacheStore.GetString("OfLabel")} {totalResults}</span>
            </div>
        );
    }

    private getCurrentOffset(): number {
        if (this.props.CurrentRowOffset)
            return this.props.CurrentRowOffset;
        else if (this.props.CurrentPage > 1)
            return (this.props.CurrentPage - 1) * this.props.PageSize;
        else
            return 0;
    }

    private previousPage(e: React.MouseEvent): void {
        e.preventDefault();

        this.changePageAction(-1);
    }

    private nextPage(e: React.MouseEvent): void {
        e.preventDefault();

        this.changePageAction(1);
    }

    private changePageAction(pageChange: number): void {
        const currentOffset = this.getCurrentOffset();

        let newOffset = currentOffset + (pageChange * this.props.PageSize);

        if (newOffset < 0)
            newOffset = 0;

        if (newOffset > this.props.TotalRows || newOffset === currentOffset)
            return;

        const pageNumber = Math.floor(newOffset / this.props.PageSize) + 1;

        if (this.props.changePageFunction)
            this.props.changePageFunction(pageNumber);
        else
            sessionStore.dispatch(this.props.EventToDispatchOnPageChange, { Page: pageNumber, Offset: newOffset });
    }
}

export { SimplePagerControl };
